var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReportDeposits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D8F4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.7014C22.3419 19.2836 21.808 18.8286 21.808 18.1507C21.808 17.3707 22.548 16.8229 23.7752 16.8229C25.0679 16.8229 25.555 17.4357 25.5925 18.3457H27.1944C27.1475 17.1014 26.3794 15.9593 24.8618 15.5879V14H22.6792V15.5693C21.2646 15.8664 20.1311 16.7764 20.1311 18.1786C20.1311 19.8407 21.5269 20.6764 23.5597 21.1593C25.3864 21.5864 25.7518 22.2271 25.7518 22.8957C25.7518 23.3879 25.3864 24.1864 23.7845 24.1864C22.2857 24.1864 21.6956 23.5179 21.6112 22.6636H20C20.0937 24.2421 21.274 25.1336 22.6792 25.4214V27H24.8712V25.4493C26.2951 25.18 27.4192 24.3721 27.4286 22.8771C27.4192 20.8343 25.6487 20.1286 24 19.7014V19.7014Z",
    fill: "#03A65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24C15.5523 24 16 24.4477 16 25V27C16 28.1046 16.8954 29 18 29H30C31.1046 29 32 28.1046 32 27V25C32 24.4477 32.4477 24 33 24V24C33.5523 24 34 24.4477 34 25V29V29C34 30.1046 33.1046 31 32 31V31H16V31C14.8954 31 14 30.1046 14 29V29V25C14 24.4477 14.4477 24 15 24V24Z",
    fill: "#03A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportDeposits);
export default __webpack_public_path__ + "static/media/ic-report-deposits.e427c763.svg";
export { ForwardRef as ReactComponent };